"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTheme_1 = require("./getTheme");
var darkTheme = getTheme_1.default({ themeName: "dark" });
exports.default = darkTheme;
//# sourceMappingURL=darkTheme.js.map